import PropTypes from 'prop-types';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import DynamicWrapper from '../DynamicWrapper';

const AnimatedRouter = ({ routes, status }) => {
  const location = useLocation();

  return <DynamicWrapper location={location} status={status} routes={routes} />;
};

AnimatedRouter.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      element: PropTypes.element.isRequired,
    }),
  ).isRequired,
  status: PropTypes.shape({
    type: PropTypes.string.isRequired,
    text: PropTypes.string,
  }),
};

const EnhancedAnimatedRouter = ({ routes, status }) => {
  return (
    <Router>
      <AnimatedRouter routes={routes} status={status} />
    </Router>
  );
};

EnhancedAnimatedRouter.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      element: PropTypes.element.isRequired,
    }),
  ).isRequired,
  status: PropTypes.shape({
    type: PropTypes.string.isRequired,
    text: PropTypes.string,
  }),
};

export default EnhancedAnimatedRouter;
